import { fetchCategoryById } from 'core_main/api/categories';
import { GetCategoryApiResponseIncludedArticle } from 'core_main/api/categories/types';
import { PublicCallback } from 'globals/types';
import { handleError } from 'globals/errors';
import {
  createArticleCallbackResponse,
  createArticlesCallbackResponse,
} from './helpers';
import { ArticleCallbackResponse, GetArticlesParameters } from './types';

export const sortArticles = (
  positions: string[],
  articles: GetCategoryApiResponseIncludedArticle[],
) => {
  return positions.reduce((acc, val) => {
    const article = articles.find((entry) => {
      return entry.attributes.article === val;
    });

    if (article) {
      const articleCallbackResponse = createArticleCallbackResponse(article);
      acc.push(articleCallbackResponse);
    }

    return acc;
  }, [] as ArticleCallbackResponse[]);
};

export const fetchAllArticles = (parameters: GetArticlesParameters) => {
  return fetchCategoryById(parameters).then((res) => {
    const { positions } = res.data.attributes;

    const articles = res?.included?.filter((entry) => entry.type === 'article');

    if (!articles || !articles.length) return [];

    return sortArticles(positions, articles);
  });
};

export const getArticles = (
  parameters: GetArticlesParameters,
  cb?: PublicCallback,
) => {
  return fetchAllArticles(parameters)
    .then((articles) => {
      const callbackResponse = createArticlesCallbackResponse(articles);

      if (typeof cb === 'function') {
        cb(callbackResponse);
      }
    })
    .catch((error) => {
      if (typeof cb === 'function') cb(null, error);
      handleError(error, { message: 'Failed to get articles' });
    });
};
